module.exports = __webpack_public_path__ + "media/images/bg/shapes/cloud-1-4fdeb8cd4d2fe9622b3c420d1de7c559.svg";